import { render, staticRenderFns } from "./HeaderDescription.vue?vue&type=template&id=358b3186&scoped=true"
import script from "./HeaderDescription.vue?vue&type=script&lang=js"
export * from "./HeaderDescription.vue?vue&type=script&lang=js"
import style0 from "./HeaderDescription.vue?vue&type=style&index=0&id=358b3186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358b3186",
  null
  
)

export default component.exports